import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

console.log('🔍 index.js: Starting React app...');

const root = ReactDOM.createRoot(document.getElementById('root'));
console.log('🔍 index.js: Root element found:', !!document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

console.log('🔍 index.js: React app rendered');
